import { isDevelopment } from '@/helpers/utils';

const vacations = [
  {
    title: 'وطن العدالة الناجزة',
    from: '2024-02-21T14:15:00+03:00',
    to: '2024-02-25T08:00:00+03:00',
    message: 'تهنئكم وزارة العدل بيوم التأسيس، وتود إشعاركم بإيقاف استقبال طلبات الخدمات العدلية الإلكترونية ابتداءً من نهاية يوم عمل (الأربعاء) بتاريخ (11 شعبان 1445هـ) الموافق (21 فبراير 2024مـ)، وسيتاح تقديم الخدمة يوم (الأحد) بتاريخ (15 شعبان 1445هـ) الموافق (25 فبراير 2024مـ) الساعة(8 صباحاً).',
  },
  {
    title: 'وطن العدالة الناجزة',
    from: '2023-02-21T14:15:00+03:00',
    to: '2023-02-26T08:00:00+03:00',
    message: 'تهنئكم وزارة العدل بيوم التأسيس، وتود إشعاركم بإيقاف استقبال طلبات الخدمات العدلية الإلكترونية ابتداءً من نهاية دوام يوم (الثلاثاء) بتاريخ (1 شعبان 1444هـ) الموافق (21 فبراير 2023مـ)، وسيتاح تقديم الخدمة يوم (الأحد) بتاريخ (6 شعبان 1444هـ) الموافق (26 فبراير 2023مـ) الساعة(8 صباحاً).',
  },
  {
    title: 'عيد الفطر المبارك',
    from: '2023-04-13T15:00:00+03:00',
    to: '2023-04-26T08:00:00+03:00',
    message: 'تهنئكم وزارة العدل بقدوم عيد الفطر المبارك، وتود إشعاركم بإيقاف استقبال طلبات صحائف الدعوى ابتداءً من يوم (الخميس) بتاريخ(22 رمضان1444 هـ) الموافق(13 إبريل 2033م)، وسيتاح تقديم الخدمة يوم(الأربعاء) بتاريخ(6 شوال 1444ه) الموافق(26 إبريل 2023م.) الساعة(8:00 صباحاً).',
  },
  {
    title: 'عيد الأضحى المبارك',
    from: '2023-06-22T14:15:00+03:00',
    to: '2023-07-04T08:00:00+03:00',
    message: 'تهنئكم وزارة العدل بقدوم عيد الأضحى المبارك ، وتود إشعاركم بإيقاف استقبال طلبات صحائف الدعوى وطلبات الإفلاس ابتداءً من يوم (الخميس) بتاريخ(4 ذو الحجة 1444 هـ) الموافق(22 يونيو 2023م)، وسيتاح تقديم الخدمة يوم(الثلاثاء) بتاريخ(16 ذو الحجة  1444ه) الموافق(4 يوليو 2023م.) الساعة(8:00 صباحاً)',
  },
  {
    title: 'اليوم الوطني',
    from: '2024-09-19T18:30:00+03:00',
    to: '2024-09-24T08:00:00+03:00',
    message: 'تهنئكم وزارة العدل باليوم الوطني 94، وسيتم استقبال طلبات صحائف الدعوى وطلبات الإفلاس يوم(الثلاثاء) بتاريخ(٢١ ربيع الأول  ١٤٤٦هـ ) الموافق(٢٤ سبتمبر ٢٠٢٤ م) الساعة(٠٨:٠٠ صباحاً)',
  },
  {
    title: 'وطن العدالة الناجزة',
    from: '2022-11-23T08:00:00+03:00',
    to: '2022-11-24T08:00:00+03:00',
    message: 'تهنئكم وزارة العدل بفوز المنتخب السعودي، وتود إشعاركم بإيقاف استقبال طلبات الخدمات العدلية الإلكترونية ابتداءً من يوم (الإربعاء.) بتاريخ(١٤٤٤/٤/٢٩ هـ) الموافق(٢٠٢٢/١١/٢٣ م)، وسيتاح تقديم الخدمة يوم(الخميس) بتاريخ(١٤٤٤/٤/٣٠ هـ) الموافق(٢٠٢٢/١١/٢٤ م) الساعة(الثامنة صباحاً).',
  },
  {
    title: 'عيد الفطر المبارك',
    from: '2024-04-03T15:00:00+03:00',
    to: '2024-04-15T08:00:00+03:00',
    message: 'تهنئكم وزارة العدل بقدوم عيد الفطر المبارك ، وتود إشعاركم بإيقاف استقبال الطلبات، وسيتاح تقديم الخدمة يوم(الأثنين) بتاريخ( 6 شوال 1445ه) الموافق( 15 أبريل 2024م) الساعة(00: 8صباحاً).',
  },
  {
    title: 'عيد الأضحى المبارك',
    from: '2024-06-10T14:30:00+03:00',
    to: '2024-06-23T08:00:00+03:00',
    message: 'تهنئكم وزارة العدل بقدوم عيد الأضحى المبارك ، وتود إشعاركم بإيقاف استقبال طلبات صحائف الدعوى وطلبات الإفلاس وسيتاح تقديم الخدمة يوم(الاحد) بتاريخ(17 ذو الحجة  1445هـ) الموافق(٢٣ يونيو 2024م) الساعة(8:00 صباحاً)',
  },
  {
    title: 'يوم التأسيس',
    from: '2025-02-20T14:30:00+03:00',
    to: '2025-02-24T08:00:00+03:00',
    message: 'تهنئكم وزارة العدل بيوم التأسيس، وتود إشعاركم بإيقاف استقبال طلبات الخدمات العدلية الإلكترونية ابتداءً من نهاية يوم عمل (الخميس) بتاريخ (21 شعبان 1446هـ) الموافق (20 فبراير 2025م)، وسيتاح تقديم الخدمة يوم (الاثنين) بتاريخ ( 25 شعبان 1446هـ) الموافق (24 فبراير 2025م) الساعة(8 صباحاً).',
  },
  {
    title: 'عيد الفطر المبارك',
    from: '2025-03-24T15:00:00+03:00',
    to: '2025-04-06T08:00:00+03:00',
    message: 'تهنئكم وزارة العدل بقدوم عيد الفطر المبارك؛ وتود إشعاركم بإيقاف استقبال الطلبات؛ وسيتاح تقديم الخدمة يوم(الأحد) بتاريخ( ٨ شوال ١٤٤٦هـ) الموافق( ٦ أبريل ٢٠٢٥م).',
  },
  {
    title: 'وطن العدالة الناجزة',
    from: '2025-05-29T14:15:00+03:00',
    to: '2025-06-15T08:00:00+03:00',
    message: 'تهنئكم وزارة العدل بقدوم عيد الأضحى المبارك، وتود إشعاركم بإيقاف استقبال طلبات الخدمات العدلية الإلكترونية ابتداءً من يوم (الخميس) بتاريخ(2 ذو الحجة 1446 هـ) الموافق(29 مايو 2025م)، و سيتاح تقديم الخدمة يوم (الأحد) بتاريخ (19ذو الحجة 1446هـ) الموافق(15 يونيو 2025م) الساعة (8 صباحًا)',
  },
  {
    title: 'عيد الفطر المبارك',
    from: '2026-03-12T14:30:00+03:00',
    to: '2026-03-25T08:00:00+03:00',
    message: 'عزيزي المستفيد، نهنئكم بحلول عيد الفطر المبارك، أعاده الله علينا وعليكم باليمن والمسرات. كما نسعد بخدمتكم عند استئناف العمل بعد إجازة عيد الفطر المبارك يوم الأربعاء الموافق(6 شوال 1447هـ). وكل عام وأنتم بخير',
  },
  {
        title: 'عيد الأضحى المبارك',
        from: '2026-05-21T14:00:00+03:00',
        to: '2026-06-02T00:01:00+03:00',
      message: 'عزيزي المستفيد، نهنئكم بحلول عيد الأضحى المبارك، أعاده الله علينا وعليكم باليمن والمسرات. كما نسعد بخدمتكم عند استئناف العمل يوم الثلاثاء الموافق (2 يونيو 2026). كل عام وأنتم بخير.',
  },
];

const check = () => {
  if (isDevelopment()) {
    return { locked: false, message: null };
  }

  const now = Date.now();
  let activeVacation = null;

  for (let i = 0; i < vacations.length; i++) {
    try {
      const fromTime = new Date(vacations[i].from).getTime();
      const toTime = new Date(vacations[i].to).getTime();

      if (now >= fromTime && now <= toTime) {
        activeVacation = vacations[i];
        break;
      }
    } catch (error) {
      console.warn('Invalid vacation date format:', vacations[i].from, vacations[i].to);
    }
  }

  return activeVacation
    ? { locked: true, message: activeVacation.message }
    : { locked: false, message: null };
};

export default {
  check,
};